<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">绑定手机号码</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container>
        <div style="width:95%;margin:auto;padding-top:1rem;">
          <div>
            <v-text-field v-model="tel" label="手机号码" @change="changeTel" class="us_v_text" counter="15" />
          </div>
          <div style="margin-top:1rem;">
            <!-- 阿里云滑块组件 -->
            <!-- <nocaptcha :appkey="'FFFF0N00000000006990'" lang="cn" scene="nc_register" class="us_no_captcha" @callback="sliderCallBack" /> -->
          </div>
          <div style="position:relative;margin-top:1rem;">
            <!-- <span style="font-size:14px;">验证码</span> -->
            <v-text-field v-model="verifyCode" label="验证码" class="us_v_text" counter="6" />
            <v-btn dark small color="#5BBAF5" class="us_icon_btn" @click="sendTelVerifyCode">
              <span v-if="!verifyCodeState">获取手机验证码</span>
              <span v-else>{{codeIndate}} 秒后可重新获取</span>
            </v-btn>
          </div>
          <div style="text-align:center;margin-top:2.5rem;">
            <v-btn style="width:80%;" color="success" large @click="goBind">确定绑定</v-btn>
          </div>
          <div style="margin-top:4rem;font-size:0.85rem;color:#616161;">
            <div>提示</div>
            <div style="padding-left:0.3rem;">
              <div>1. 绑定成功后，即可登录电脑端，登录账号： 手机号码，默认登录密码： 123</div>
              <div>2. 电脑端地址：http://ops.gz7x24.cn</div>
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// 阿里云滑块组件
// import { nocaptcha } from 'vue-nocaptcha'
export default {
  components: { },
  props: {
  },
  data() {
    return {
      tel: '',
      verifyCode: '',
      codeIndateDef: 60,
      verifyCodeState: false,
      codeIndate: 0,
      timeout: null
    }
  },
  computed: {
  },
  mounted() {
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  created() {
  },
  methods: {
    // 返回
    goBack() {
      this.$router.goBack()
    },
    // 绑定手机号码
    async goBind() {
      var that = this
      if (!that.tel || that.tel === '') {
        that.$toast.warning('请输入手机号码')
        return
      }
      if (that.tel.length < 11) {
        that.$toast.warning('请输入正确手机号码')
        return
      }
      if (!that.verifyCode || that.verifyCode === '') {
        that.$toast.warning('请输入验证码')
        return
      }
      if (that.verifyCode.length != 6) {
        that.$toast.warning('请输入正确验证码')
        return
      }
      // 检查输入的手机验证码
      var res1 = await that.$api.bz.checkTelVerifyCode({ tel: that.tel, verify_code: that.verifyCode });
      // console.log('checkTelVerifyCode.res', res1);
      if (!res1.success) {
        that.$toast.warning(res1.error_msg)
        return
      }
      var res = await that.$api.bz.bindTel({ tel: that.tel, verify_code: that.verifyCode })
      // console.log('bindTel.res', res);
      if (!res.success) {
        // 前面有检查这里就可以删除了
        if (res.error_msg === '这个手机号码已经被绑定过了') {
          that.$toast.warning(res.error_msg)
          return
        }
        that.$router.goActionResPage({ tag: 0, text: '绑定失败', auto_ret: 'b' })
        return
      }
      that.$router.goActionResPage({ tag: 1, text: '绑定成功', auto_ret: 'n', dest: -2, desc: '默认登录密码: 123', back_btn_vis: 1 })
    },
    // 发送手机验证码
    async sendTelVerifyCode() {
      var that = this
      if (that.verifyCodeState) {
        return
      }
      if (that.tel === '') {
        that.$toast.warning('请输入手机号码')
        return
      }
      // 请求发送手机验证码
      var res = await that.$api.bz.sendTelVerifyCode({ tel: that.tel, reg: true });
      // console.log('sendTelVerifyCode.res', res);
      if (!res.success) {
        that.$toast.warning(res.error_msg)
        console.log('请求发送手机验证码失败.res', res);
        return
      }
      // 发送成功后
      that.$toast.success('发送成功')
      that.verifyCodeState = true
      that.codeIndate = that.codeIndateDef
      that.verifyDisabledTask()
    },
    // 更改手机号码
    changeTel() {
      var that = this
      that.verifyCode = ''
    },
    // 60秒后可重新获取
    verifyDisabledTask() {
      var that = this
      if (that.timeout) {
        window.clearTimeout(that.timeout)
      }
      that.codeIndate--
      if (that.codeIndate <= 0) {
        that.verifyCodeState = false
        // console.log('可重新获取验证码.');
        return
      }
      that.timeout = setTimeout(that.verifyDisabledTask, 1 * 1000)
    },
    // 滑块成功回调
    sliderCallBack(e) {
      console.log('e', e);
      var that = this
      that.sendTelVerifyCode()
    }
  }
}
</script>

<style scoped>
.us_icon_btn {
  position: absolute;
  right: 0px;
  top: 11px;
  /* min-width: 138px !important; */
}
.us_v_text /deep/ .v-label{
  font-size: 0.9rem;
}
.us_v_text /deep/ .v-label--active{
  font-size: 1.03rem !important;
}
.us_no_captcha /deep/ ._nc .stage1{
  height: 35px !important;
  width: 100%;
  padding: 0;
}
.us_no_captcha /deep/._nc .stage1 .slider{
  height: 35px;
}
.us_no_captcha /deep/ ._nc .stage1 .label{
  line-height: 35px;
  height: 35px;
  font-size: 14px;
}
.us_no_captcha /deep/ ._nc .stage1 .button{
  width: 35px;
  height: 35px;
}
.us_no_captcha /deep/ ._nc .stage1 .icon {
  position: absolute;
  left: 5px;
  top: 3px;
}
.us_no_captcha /deep/ ._nc .icon-slide-arrow {
  font-size: 25px;
  color: #dbdbdb;
}
.us_no_captcha /deep/ ._nc .stage1 .track div{
  width: 35px;
  height: 35px;
}
</style>
